import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  const locale = sessionStorage.getItem('versant_locale') || 'en';

  const translations = {
    en: {
      title: "Privacy Policy",
      welcome: "This privacy policy sets out how we use and protect any information that you give us when you use this website.",
      h1: "1. Information We Collect",
      p1: "We may collect the following information:",
      b1_1: "Name and contact information including email address",
      b1_2: "Demographic information such as postcode, preferences and interests",
      b1_3: "Other information relevant to customer surveys and/or offers",
      h2: "2. How We Use Your Information",
      p2: "We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:",
      b2_1: "Internal record keeping.",
      b2_2: "We may use the information to improve our products and services.",
      b2_3: "We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided.",
      h3: "3. Security",
      p3: "We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.",
      h4: "4. Cookies",
      p4: "A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site. We use traffic log cookies to identify which pages are being used.",
      h5: "5. Links to Other Websites",
      p5: "Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement.",
      h6: "6. Controlling Your Personal Information",
      p6: "You may choose to restrict the collection or use of your personal information. If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us."
    },
    es: {
      title: "Política de Privacidad",
      welcome: "Esta política de privacidad establece cómo usamos y protegemos cualquier información que nos proporcione al usar este sitio web.",
      h1: "1. Información que Recopilamos",
      p1: "Podemos recopilar la siguiente información:",
      b1_1: "Nombre e información de contacto, incluida la dirección de correo electrónico.",
      b1_2: "Información demográfica como código postal, preferencias e intereses.",
      b1_3: "Otra información relevante para encuestas y/u ofertas de clientes.",
      h2: "2. Cómo Usamos tu Información",
      p2: "Requerimos esta información para comprender sus necesidades y brindarle un mejor servicio, en particular por las siguientes razones:",
      b2_1: "Mantenimiento de registros internos.",
      b2_2: "Podemos utilizar la información para mejorar nuestros productos y servicios.",
      b2_3: "Podemos enviar correos electrónicos promocionales periódicamente sobre nuevos productos, ofertas especiales u otra información que creamos que pueda resultarle interesante.",
      h3: "3. Seguridad",
      p3: "Nos comprometemos a garantizar que su información esté segura. Con el fin de evitar el acceso o la divulgación no autorizados, hemos implementado procedimientos físicos, electrónicos y administrativos adecuados para salvaguardar la información.",
      h4: "4. Cookies",
      p4: "Una cookie es un pequeño archivo que solicita permiso para colocarse en el disco duro de su computadora. Una vez que acepta, el archivo se agrega y la cookie ayuda a analizar el tráfico web o le permite saber cuándo visita un sitio en particular.",
      h5: "5. Enlaces a otros Sitios Web",
      p5: "Nuestro sitio web puede contener enlaces a otros sitios de interés. Sin embargo, una vez que haya utilizado estos enlaces para salir de nuestro sitio, debe tener en cuenta que no tenemos ningún control sobre ese otro sitio web.",
      h6: "6. Control de su Información Personal",
      p6: "Puede optar por restringir la recopilación o el uso de su información personal. Si previamente aceptó que usemos su información para fines de marketing directo, puede cambiar de opinión en cualquier momento."
    },
    pt: {
      title: "Política de Privacidade",
      welcome: "Esta política de privacidade define como usamos e protegemos qualquer informação que você nos fornece ao usar este site.",
      h1: "1. Informações que Coletamos",
      p1: "We may collect the following information:",
      b1_1: "Nome e informações de contato, incluindo endereço de e-mail.",
      b1_2: "Informações demográficas, como código postal, preferências e interesses.",
      b1_3: "Outras informações relevantes para pesquisas de clientes e/ou ofertas.",
      h2: "2. Como Usamos Suas Informações",
      p2: "Exigimos essas informações para entender suas necessidades e fornecer um serviço melhor, em particular pelas seguintes razões:",
      b2_1: "Manutenção de registros internos.",
      b2_2: "Podemos usar as informações para melhorar nossos produtos e serviços.",
      b2_3: "Podemos enviar e-mails promocionais periodicamente sobre novos produtos, ofertas especiais ou outras informações que achamos que você pode achar interessantes.",
      h3: "3. Segurança",
      p3: "Estamos empenhados em garantir que suas informações estejam seguras. Para evitar o acesso ou divulgação não autorizados, implementamos procedimentos físicos, eletrônicos e gerenciais adequados para proteger as informações.",
      h4: "4. Cookies",
      p4: "Um cookie é um pequeno arquivo que pede permissão para ser colocado no disco rígido do seu computador. Uma vez que você concorda, o arquivo é adicionado e o cookie ajuda a analisar o tráfego da web.",
      h5: "5. Links para Outros Sites",
      p5: "Nosso site pode conter links para outros sites de interesse. No entanto, uma vez que você tenha usado esses links para sair do nosso site, observe que não temos controle sobre o outro site.",
      h6: "6. Controle de Suas Informações Pessoais",
      p6: "Você pode optar por restringir a coleta ou uso de suas informações pessoais. Se você concordou anteriormente com o uso de suas informações para fins de marketing, pode mudar de ideia a qualquer momento."
    },
    ja: {
      title: "プライバシーポリシー",
      welcome: "本プライバシーポリシーは、お客様が当ウェブサイトを利用する際にご提供いただく情報の取り扱いおよび保護について定めるものです。",
      h1: "1. 収集する情報",
      p1: "当サイトは、以下の情報を収集する場合があります。",
      b1_1: "氏名およびメールアドレスを含む連絡先情報",
      b1_2: "郵便番号、ユーザー設定、関心事などのデモグラフィック情報",
      b1_3: "顧客アンケートやキャンペーン等に関連するその他の情報",
      h2: "2. 収集した情報の利用目的",
      p2: "収集した情報は、お客様のニーズを把握し、より良いサービスを提供するために利用され、特に以下の目的で利用されます。",
      b2_1: "社内の記録管理",
      b2_2: "製品およびサービスの向上のための分析",
      b2_3: "ご登録いただいたメールアドレス宛に、新製品、特別オファー、その他有益と思われる情報を定期的にお送りするため",
      h3: "3. セキュリティ",
      p3: "私たちは、お客様の情報の安全性を確保することに努めています。不正なアクセスや漏洩を防ぐため、オンラインで収集した情報を保護するための適切な物理的、技術的、組織的な管理措置を講じています。",
      h4: "4. クッキー（Cookies）について",
      p4: "クッキーは、お客様のコンピュータのハードドライブに保存の許可を求める小さなファイルです。同意するとファイルが追加され、ウェブトラフィックの分析や特定サイトへの訪問の追跡に役立ちます。当サイトは、どのページが利用されているかを特定するためにアクセスログ用のクッキーを使用します。",
      h5: "5. 他のウェブサイトへのリンク",
      p5: "当サイトには、外部サイトへのリンクが含まれる場合があります。リンク先の外部サイトはお客様が当サイトを離れた後は管理対象外となります。そのため、外部サイトでの個人情報の保護およびプライバシーについて、当サイトは一切の責任を負いません。",
      h6: "6. 個人情報の管理について",
      p6: "お客様は、個人情報の収集または利用を制限することを選択できます。以前にマーケティング目的での個人情報の利用に同意した場合でも、いつでも書面またはメールにて同意を撤回することができます。"
    }
  };

  const t = translations[locale] || translations.en;

  return (
    <>
      <Helmet>
        <title>{t.title} | Versant Practice Test</title>
        <meta name="description" content="Read the privacy policy for the Versant Practice Test website." />
      </Helmet>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-10 rounded-lg shadow-md">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-6">{t.title}</h1>
          <div className="prose prose-lg max-w-none">
            <p>{t.welcome}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h1}</h2>
            <p>{t.p1}</p>
            <ul>
              <li>{t.b1_1}</li>
              <li>{t.b1_2}</li>
              <li>{t.b1_3}</li>
            </ul>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h2}</h2>
            <p>{t.p2}</p>
            <ul>
              <li>{t.b2_1}</li>
              <li>{t.b2_2}</li>
              <li>{t.b2_3}</li>
            </ul>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h3}</h2>
            <p>{t.p3}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h4}</h2>
            <p>{t.p4}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h5}</h2>
            <p>{t.p5}</p>

            <h2 className="text-2xl font-bold mt-6 mb-4">{t.h6}</h2>
            <p>{t.p6}</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}